import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Card, CardContent, CardMedia, Chip, Typography, Button, Box } from '@mui/material'

type Game = {
  id?: number | string
  title: string
  desc: string
  img?: string
  platforms?: string[]
  genres?: string[]
  released?: string
  rating?: number
  summary?: string
}

const FeaturedGames = ({ games }: { games: Game[] }): React.JSX.Element => {
  const navigate = useNavigate()

  if (games.length === 0) {
    return <p className="muted">No featured games available yet.</p>
  }

  return (
    <div className="featured-grid">
      {games.map((g, i) => {
        const cardKey = `${g.id ?? g.title}-${i}-${g.title}`
        return (
        <Card key={cardKey} className="card" sx={{ minHeight: 260, backgroundColor: 'rgba(255,255,255,0.06)', color: '#f8fbff', display: 'flex', flexDirection: 'column' }}>
          {g.img && <CardMedia component="img" height="130" image={g.img} alt={g.title} />}
          <CardContent sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
            <Typography variant="h6" sx={{ color: '#f8fbff', fontWeight: 700 }}>
              {g.title}
            </Typography>
            <Typography variant="body2" className="muted" sx={{ mb: 1 }}>
              {g.desc}
            </Typography>
            {g.platforms?.length ? (
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mb: 1 }}>
                {g.platforms.slice(0, 3).map((platform, platformIndex) => (
                  <Chip key={`${cardKey}-${platform}-${platformIndex}`} label={platform} size="small" sx={{ backgroundColor: '#2563eb', color: 'white' }} />
                ))}
              </Box>
            ) : null}
            <Button
              size="small"
              variant="contained"
              sx={{ fontWeight: 700, mt: 'auto' }}
              onClick={() => navigate(`/games/${g.id ?? g.title}`, { state: { game: g } })}
            >
              View
            </Button>
          </CardContent>
        </Card>
        )
      })}
    </div>
  )
}

export default FeaturedGames
